import React, { Fragment, useEffect, useState } from 'react';

import { Formik, FieldArray, useFormikContext } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import UserSelectorInput from 'CommonComponents/UserSelectorInput';

import TrashIcon from 'Assets/icons/trash.svg';

const EvaluationTemplateCreateSchema = Yup.object().shape({
    scorers: Yup.array()
        .of(
            Yup.object().shape({
                user_id: Yup.string().required($t('This value is required')),
            }),
        )
        .min(1, $t('Must have at least one user')),
});

export default function EvaluationTemplateScorersTab(props) {
    const EmailDisplay = (props) => {
        const { values } = useFormikContext();

        const getEmail = () => {
            if (values.scorers[props.index].user_id) {
                const data = props.users.find((v) => {
                    return v.id === parseInt(values.scorers[props.index].user_id);
                });

                return data ? data.email : '';
            }

            return '';
        };

        const [value, setValue] = useState(getEmail());

        useEffect(() => {
            setValue(getEmail());
        }, [values]);

        return <input type="email" className="form-control" defaultValue={value} disabled={true} />;
    };

    const defaultObject = () => {
        return {
            user_id: '',
        };
    };

    return (
        <Formik
            initialValues={{
                scorers: props.scorers.map((item) => {
                    return {
                        user_id: item.user_id || '',
                    };
                }),
            }}
            validationSchema={EvaluationTemplateCreateSchema}
            onSubmit={async (values, actions) => {
                if (confirm($t('Once the form is submitted, you will not be able to edit the template and users. Please confirm the action.'))) {
                    try {
                        await props.handleSaveTemplate('evaluators');
                        await axios
                            .put(props.storeScorersUrl, values)
                            .then((response) => {
                                window.location.href = props.redirectUrl;
                            })
                            .catch((e) => {
                                console.log(e.response);
                            })
                            .finally(() => {
                                actions.setSubmitting(false);
                            });
                    } catch (e) {
                        if (e !== undefined) {
                            console.log(e.response);
                        }
                    }
                } else {
                    actions.setSubmitting(false);
                }
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="inbud-card tw-mb-3">
                        <FieldArray
                            name="scorers"
                            render={(arrayHelpers) => (
                                <div>
                                    {values.scorers && values.scorers.length > 0 ? (
                                        values.scorers.map((scorer, index) => (
                                            <Fragment key={index}>
                                                <div className="tw-grid tw-grid-flow-col tw-auto-cols-fr tw-gap-x-3 tw-mt-6">
                                                    <div className="tw-grid tw-gap-4 tw-grid-cols-2">
                                                        <label className="tw-col-span-1 tw-text-base tw-flex tw-items-center tw-mb-0">
                                                            {$t('User')} {index + 1}
                                                        </label>
                                                        <div className={'tw-flex tw-flex-row'}>
                                                            <UserSelectorInput
                                                                placeholder="User"
                                                                selectedId={scorer.user_id}
                                                                onChange={(value) => setFieldValue(`scorers.${index}.user_id`, value)}
                                                                fetchUrl={props.listUsersUrl}
                                                                className={'tw-w-full'}
                                                            />
                                                            <button
                                                                className="tw-flex tw-flex-col tw-ml-2 tw-justify-center tw-items-center tw-text-xs"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                <TrashIcon className="tw-text-red-500 tw-w-3 tw-h-3" />
                                                            </button>
                                                        </div>
                                                        {errors.scorers &&
                                                            errors.scorers[index] &&
                                                            errors.scorers[index].user_id &&
                                                            ((touched.scorer && touched.scorer[index] && touched.scorer[index].user_id) ||
                                                                (touched.scorers && touched.scorers[index] && touched.scorers[index].user_id)) && (
                                                                <div className="tw-col-start-2 tw-text-red-500">{errors.scorers[index].user_id}</div>
                                                            )}
                                                    </div>
                                                </div>

                                                {values.scorers.length - 1 === index && (
                                                    <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                                        <button type="button" className="button primary" onClick={() => arrayHelpers.push(defaultObject())}>
                                                            {$t('Add a user')}
                                                        </button>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))
                                    ) : (
                                        <>
                                            <p className={'tw-text-base'}>{$t('There are no Evaluators at this evaluation template')}</p>
                                            <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                                <button type="button" className="button primary" onClick={() => arrayHelpers.push(defaultObject())}>
                                                    {$t('Add a user')}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    <div className="mt-3">
                                        <Button variant="primary" disabled={isSubmitting || values.scorers.length === 0} onClick={handleSubmit}>
                                            {$t('Submit')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </>
            )}
        </Formik>
    );
}
